/**
 * Internal: only Foresight super admins (Clerk `publicMetadata.admin`) see
 * the Public sector tab.
 */
export const canAccessPublicSector = (
  user:
    { id: string; publicMetadata?: Record<string, unknown> } | null | undefined
): boolean => !!user && user.publicMetadata?.admin === true;
